import { getItem, setItem, isLocalStorageEnabled } from '@client/utils/storage';
import { replyCrossOrigin, CrossOriginAction, CrossOriginMessage } from './message';

window.addEventListener('message', async (e) => {
  if (e.source !== window.parent || !e.ports[0] || typeof e.data !== 'object') {
    return;
  }

  const port = e.ports[0];

  try {
    const { action, payload } = e.data as CrossOriginMessage;

    switch (action) {
      case CrossOriginAction.CheckLocalStorage: {
        replyCrossOrigin(port, isLocalStorageEnabled());
        break;
      }
      case CrossOriginAction.GetItem: {
        if (typeof payload?.key !== 'string') {
          throw Error('Get Item: Invalid key');
        }

        replyCrossOrigin(port, getItem(payload?.key));
        break;
      }
      case CrossOriginAction.SetItem: {
        if (typeof payload?.key !== 'string') {
          throw Error('Set Item: Invalid key');
        }
        if (typeof payload?.value !== 'string') {
          throw Error('Set Item: Invalid value');
        }
        const { key, value } = payload;
        replyCrossOrigin(port, setItem(key, value));
        break;
      }
      default: {
        throw Error('Unknown action');
      }
    }
  } catch (err) {
    replyCrossOrigin(port, err);
  }
});
